import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { MenuContentItem, MenuDisplayMode, MenuSection, trackByProp } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';
import { ProductMenuService } from '@frontend/vanilla/shared/product-menu';

@Component({
    imports: [CommonModule, MenuItemComponent],
    selector: 'vn-product-menu-tabs',
    templateUrl: 'product-menu-tabs.html',
})
export class ProductMenuTabsComponent {
    @Input() useFastIconType: boolean;

    readonly MenuDisplayMode = MenuDisplayMode;
    readonly MenuSection = MenuSection;
    readonly trackByProp = trackByProp<MenuContentItem>('id');

    readonly productMenuService = inject(ProductMenuService);

    onClick(item: MenuContentItem) {
        if (item.layout) {
            this.productMenuService.openTab(item.name);
        } else if (!this.productMenuService.routerMode) {
            this.productMenuService.toggle(false);
        }
    }
}
